// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
/**
 * Sprint 48.5.x — Forseti "Buy More" billing-unit bundle pricing card.
 *
 * Source of truth for the self-service top-up SKUs. Mirrors the IAT
 * credit-package pattern (`iat-pricing.ts`): server-side validation
 * (`QuotaCounterService.purchaseTopUp`) rejects any redeem whose
 * `(package, units, price_paid_usd)` tuple does not match this table to
 * the cent, and the aesirx.io invoice-verify response is cross-checked
 * against the selected bundle before any units are credited.
 *
 * A "unit" is one billable token as defined by the 47.5.1 token bucket
 * (`grc_ai_quota_counters` — input + output + cached×0.1). Bundles are
 * added on top of the tier's monthly allowance.
 *
 * Currency is USD only in v1; non-USD ladders are out of scope.
 *
 * Prices + unit sizes are product-confirmed (2026-07-07):
 *   starter  $100  → 3,200,000 units
 *   growth $500  → 17,500,000 units
 *   enterprise  $1000 → 37,500,000 units
 */
export const FORSETI_BUNDLES = {
    starter: { units: 3_200_000, price_usd: 100.0 },
    growth: { units: 17_500_000, price_usd: 500.0 },
    enterprise: { units: 37_500_000, price_usd: 1_000.0 },
};
/** All bundle codes as a readonly array (UI dropdowns / validators). */
export const FORSETI_BUNDLE_CODES = [
    'starter',
    'growth',
    'enterprise',
];
//# sourceMappingURL=forseti-billing.js.map